import Main from './Main'
import Configuracoes from './components/Configuracoes'
import Mensagens from './components/Mensagens'

export default [
  { path: '/perfil', component: Main, name: 'perfil.main' },
  { path: '/perfil/configuracoes', component: Configuracoes, name: 'perfil.configuracoes' },
  { path: '/perfil/mensagens', component: Mensagens, name: 'perfil.mensagens' },
]
